// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import MainLayout from '../../layouts/MainLayout';
import Timer from '../../components/Timer';
import Overview from './components/Overview';
import LabMarkdown from './components/LabMarkdown';
import LabTimeUpDialog from './components/LabTimeUpDialog';
import Notepad from '../../components/Notepad';
import { clearNote } from '../../components/Notepad/Notepad';
import LoadingIcon from '../../components/LoadingIcon';

import QuestionnairePage from '../QuestionnairePage';
import { parseDuration, useQuery, getQueryParams, useUpdateEffect } from '../../lib/utility';
import { S } from './LabPageStyle';
import MemberContext from '../../contexts/MemberContext';
import LabSelector from '../../redux/selectors/LabSelector';
import { CreditMethod, RunningLabSourceFrom } from '../../types/Model';
import { makeFooterVisibleHeight } from '../../redux/selectors/mainLayoutSelector/mainLayoutSelector';

import MultilineText from '../../components/MultilineText';
import { useParamsId } from '../../lib/utility';
import {
  useFetchLabInformation,
  useMarkdowns,
  useBuyLab,
  useTestLab,
  useEndLab,
  useLoadLabScroll,
  useSaveLabScroll,
  useIsNavigationScrolling,
  useUpdateRunningLab,
  useSendVisitLab
} from './hooks';
import { FormattedMessage } from 'react-intl';

const REFRESH_INTERVAL = 14 * 60 * 1000;

const LabPage = (): JSX.Element => {
  const creditMethod = CreditMethod.OrganizationCredit; // [TODO] selected by user
  const member = useContext(MemberContext);
  const id = useParamsId();
  const query = getQueryParams(useQuery()) as { workshopId?: string, condition?: string, courseId?: string, iltCourseId?: string};
  const { condition } = query;

  // Navigation States
  const isNavigationScrolling = useIsNavigationScrolling();
  const [isClickNavigation, setClickNavigation] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const footerVisibleHeight = useSelector(makeFooterVisibleHeight());
  // lab info states
  const lab = useSelector(LabSelector.makeLabByIdSelector(id));
  const isFetchingLab = useSelector(LabSelector.makeIsFetchingLab());
  const labErrors = useSelector(LabSelector.makeError());
  // markdown states
  const [isMarkdownShow, setIsMarkdownShow] = useState(false);
  const [markdowns, isMarkdownFetching] = useMarkdowns(lab, isFetchingLab);

  const [isLabTimeUpDialogShow, setIsLabTimeUpDialogShow] = useState(false);
  const [isShowCongratulation, setIsShowCongratulation] = useState(false);
  // Timer states
  const [endLabTime, setEndLabTime] = useState<Date>();
  // Workshop States
  const workshopId = query.workshopId ? parseInt(query.workshopId, 10) : undefined;
  const { endTime } = lab.relatedWorkshop || { endTime: new Date() };
  const courseId = query.courseId ? parseInt(query.courseId, 10) : undefined;
  const iltCourseId = query.iltCourseId ? parseInt(query.iltCourseId, 10) : undefined;

  const fetchLab = useFetchLabInformation(id, { workshopId, iltCourseId });
  const refreshLab = useFetchLabInformation(id, { workshopId, preventLoading: true, iltCourseId });
  const visitLab = useSendVisitLab(id);
  // for questionnaire
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [labRecordId, setLabRecordId] = useState<number>();

  useEffect(() => {
    const interval = setInterval(() => {
      if (lab.runningInfo) {
        console.log('refresh');
        refreshLab();
      }
    }, REFRESH_INTERVAL);

    return () => {
      clearInterval(interval);
    }
  }, [refreshLab, lab.runningInfo])

  useEffect(() => {
    fetchLab();
    visitLab();
  }, [id, workshopId, iltCourseId]);

  useUpdateEffect(() => {
    if (lab.runningInfo) {
      setIsMarkdownShow(true);
    } else {
      setIsMarkdownShow(false);
    }
  }, [lab]);

  useEffect(() => {
    member.update();
  }, [lab.runningInfo]);

  useEffect(() => {
    if (member.runningLab) {
      setLabRecordId(member.runningLab.recordId);
    }
  }, [member.runningLab]);

  useLoadLabScroll(markdowns);
  useSaveLabScroll(markdowns);

  const updateRunningLab = useUpdateRunningLab();

  const buyLab = useBuyLab(id, {
    creditMethod,
    workshopId,
    courseId,
    iltCourseId,
    success: () => fetchLab(),
    onError: () => {
      updateRunningLab({
        id,
        sourceFrom: workshopId ? RunningLabSourceFrom.Workshop : RunningLabSourceFrom.Ilt,
        sourceId: workshopId ? workshopId : iltCourseId,
      })
    },
  })

  const testLab = useTestLab(id, {
    success: () => {
      clearNote();
      fetchLab();
    },
    onError: () => {
      updateRunningLab({
        id,
        sourceFrom: RunningLabSourceFrom.Test,
        sourceId: undefined,
      })
    }
  });

  const endLab = useEndLab(id, () => { fetchLab() })

  const handleBuyLab = () => {
    localStorage.removeItem('labScrollY');
    clearNote();
    setEndLabTime(undefined);
    setCurrentIndex(0);
    updateRunningLab({ id })
    buyLab();
  }

  const handleTestLab = () => {
    testLab();
  }

  const handleNavigate = (index: number) => {
    setClickNavigation(true);
    setCurrentIndex(index);
  }

  const handleEndLab = () => {
    setIsShowCongratulation(true);
    setEndLabTime(new Date());
    endLab();
  }

  const handleCongratulationEnd = () => {
    setIsShowCongratulation(false);
    setIsMarkdownShow(false);
    if (condition !== 'Test') {
      setShowQuestionnaire(true);
    }
  }

  const handleTimeUp = () => {
    setIsLabTimeUpDialogShow(true);
    setIsMarkdownShow(false);
  }

  const handleCloseLabTimeUpDialog = () => {
    setIsLabTimeUpDialogShow(false);
    if (condition !== 'Test') {
      setShowQuestionnaire(true);
    }
    fetchLab();
  }

  if (showQuestionnaire) {
    const basicInfo: any = {
      memberId: member.id,
      sourceId: workshopId ? workshopId : courseId ? courseId : iltCourseId ? iltCourseId : null,
      sourceFrom: workshopId ? 'workshop' : courseId ? 'onlineCourse' : iltCourseId ? 'iltCourse' : 'own',
      handsOnType: 'lab',
      handsOnId: id,
      handsOnRecordId: labRecordId,
    }
    return (
      <MainLayout>
        <S.PopMask>
          <S.QuestionnaireContainer>
            <QuestionnairePage basicInfo={basicInfo} setShowQuestionnaire={setShowQuestionnaire}/>
          </S.QuestionnaireContainer>
        </S.PopMask>
      </MainLayout>
    )
  }

  if (isFetchingLab) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <LoadingIcon size={20} />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (labErrors) {
    return (
      <MainLayout>
        <S.LabErrorContainer>
          <S.LabErrorForbiddenImage alt="lab-error" />
          <S.ErrorText><FormattedMessage id="E015" /></S.ErrorText>
          {/* <S.ErrorText>{JSON.stringify(labErrors)}</S.ErrorText> */}
          <S.ErrorButton as={Link} to={'/labs'} ><FormattedMessage id="E016" /></S.ErrorButton>
        </S.LabErrorContainer>
      </MainLayout>
    );
  }

  const renderRunning = (): JSX.Element | undefined => {
    if (lab.runningInfo) { // This lab is running
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{
              <Timer
                startedTime={new Date(lab.runningInfo.startTime)}
                endLabTime={endLabTime}
                duration={lab.duration}
                onTimesUp={handleTimeUp}
              />}
            </S.TimerDurationText>
            <S.StartButton as={'a'} href={lab.runningInfo.labInfo.loginLink} target="_blank"><FormattedMessage id={lab.code === 'AWS' ? 'E012' : 'E012-2'} /></S.StartButton>
          </S.StartStopContainer>
        </>
      )
    }

    if (!member.isLoading && member.runningLab) { // Other lab is running
      const query = member.runningLab.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningLab.sourceId}` :
        member.runningLab.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningLab.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningLab.sourceId}` : '';
      const url = `/labs/${member.runningLab.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(lab.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="E002" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="E009" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="E010" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }

    if (!member.isLoading && member.runningChallenge) { // Other challenge is running
      const query = member.runningChallenge.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningChallenge.sourceId}` :
        member.runningChallenge.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningChallenge.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningChallenge.sourceId}` : '';
      const url = `/challenges/${member.runningChallenge.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(lab.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="E002" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="E009" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="E041" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }

    if (!member.isLoading && member.runningExam) { // Other exam is running
      const query = member.runningExam.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningExam.sourceId}` :
        member.runningExam.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningExam.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningExam.sourceId}` : '';
      const url = `/exams/${member.runningExam.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(lab.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="E002" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="K014" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="K016" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }
  }

  const renderCreditBuyCondition = () => {
    if (lab.costCredit) {
      const memberCredit = (creditMethod === CreditMethod.OrganizationCredit ? member.organizationCredit : member.organizationCredit) || 0;
      const isEnough = lab.costCredit <= memberCredit;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(lab.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={!isEnough}><FormattedMessage id="E001" /></S.StartButton>
            {isEnough && (
              <S.ConfirmStartContainer>
                <S.ConfirmStartTitle><FormattedMessage id="E003" values={{ credit: lab.costCredit }} /></S.ConfirmStartTitle>
                <S.StartButton onClick={handleBuyLab}><FormattedMessage id="E004" /></S.StartButton>
              </S.ConfirmStartContainer>
            )}
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.CreditAmount>
              <FormattedMessage id="E005" values={{ credit: lab.costCredit, creditEl: <S.Credit>{lab.costCredit}</S.Credit> }} />
              <S.Notion />
            </S.CreditAmount>
            <S.DescriptionText>
              {<FormattedMessage id={isEnough ? 'E006' : 'E007'} values={{ credit: memberCredit, creditEl: <S.DescriptionCreditText>{memberCredit}</S.DescriptionCreditText> }} />}
            </S.DescriptionText>
            {
              !isEnough && (
                <S.DescriptionText>
                  {member.organizationId ? (
                    <FormattedMessage id="E008" values={{ br: <br />, managerEmail: <S.DescriptionEmailText href={`mailto:${lab.organizationContactEmail}`}>{lab.organizationContactEmail}</S.DescriptionEmailText> }} />
                  ) : (
                    null
                    // <>請購買 Credit 以繼續</> /**未來有做B2C的話要補這塊 */
                  )}
                </S.DescriptionText>
              )
            }
          </S.DescriptionContainer>
        </>
      )
    }
  }

  const renderBuying = (): JSX.Element | null => {
    if (isFetchingLab || isMarkdownFetching) {
      return null;
    }
    if (condition === 'Test' && member.isManager) {
      return (
        <S.StartStopContainer>
          <S.TimerDurationText>{parseDuration(lab.duration).all}</S.TimerDurationText>
          <S.StartButton onClick={handleTestLab}>測試實驗</S.StartButton>
        </S.StartStopContainer>
      )
    }

    if (workshopId || iltCourseId) {
      return (
        <S.StartStopContainer>
          <S.TimerDurationText>{parseDuration(lab.duration).all}</S.TimerDurationText>
          <S.StartButton onClick={handleBuyLab}><FormattedMessage id="E002" /></S.StartButton>
        </S.StartStopContainer>
      )
    } else {
      return (<>{renderCreditBuyCondition()}</>)
    }
  }

  return (
    <MainLayout>
      <S.Container inWorkshop={workshopId !== undefined}>
        <S.NavigationContainer inWorkshop={workshopId !== undefined} style={{ bottom: footerVisibleHeight + 'px' }}>
          {workshopId && <S.WorkshopLabel endTime={endTime} />}
          <S.Navigation markdowns={markdowns} isMarkdownShow={isMarkdownShow} currentIndex={currentIndex} onNavigate={handleNavigate} />
        </S.NavigationContainer>
        <S.WrapperContent>
          <S.LabName>{lab.name}</S.LabName>
          <Overview
            isClickNavigation={isClickNavigation}
            onExpanded={() => setClickNavigation(false)}
            currentIndex={currentIndex}
          ><MultilineText text={lab.overview} /></Overview>
          {
            isMarkdownFetching ? (<LoadingIcon size={10} />) : (
              lab.runningInfo && (
                <S.CollapseTransition visible={isMarkdownShow}>
                  <LabMarkdown
                    isClickNavigation={isClickNavigation}
                    onExpanded={() => setClickNavigation(false)}
                    isNavigationScrolling={isNavigationScrolling}
                    currentIndex={currentIndex}
                    markdowns={markdowns}
                    baseUrl={lab.runningInfo.markdownUrl}
                    labPassword={lab.runningInfo.labInfo.password}
                    onIndexChange={setCurrentIndex}
                  />
                  {isShowCongratulation && <S.CongratulationAnimation onEnd={handleCongratulationEnd} />}
                  <S.EndButton onClick={handleEndLab} disabled={isShowCongratulation}><FormattedMessage id="E028" /></S.EndButton>
                </S.CollapseTransition>
              )
            )
          }
        </S.WrapperContent>
        <S.WrapperSidebar inWorkshop={workshopId !== undefined}>
          {member.runningLab || member.runningChallenge || member.runningExam ? renderRunning() : renderBuying()}
        </S.WrapperSidebar>
      </S.Container>
      {lab.runningInfo && <Notepad />}
      <LabTimeUpDialog showDialog={isLabTimeUpDialogShow} closeDialog={handleCloseLabTimeUpDialog} />
    </MainLayout>
  );
}

export default LabPage;
